import React, { PureComponent, Fragment } from 'react';
import Panel from '../../../../../shared/components/Panel';
import { getDefaultChartColors } from '../../../../../shared/helpers';
import ToolTip from '../../../../../shared/components/ToolTip';

import{
	_formatNumber,
	_formatPrice,
} from '../../../../../shared/helpers/utils';


class SalesByBedrooms extends PureComponent {

  _generateSalesBreakdown = (statsRes) => {
	 if(!statsRes || !statsRes.has_bed || !statsRes.has_bed.unit_mix || !statsRes.has_bed.unit_mix.buckets){
		  return [];
	  }
	 const total = statsRes.has_bed.unit_mix.buckets.map(bucket => bucket.count).reduce((accumulator, current) => { return accumulator + current}, 0);
	 let data = statsRes.has_bed.unit_mix.buckets.sort((a, b) =>  a.val - b.val).map((bucket, i) => {
		 const stat = bucket.non_zero_price ? bucket.non_zero_price : false;
		 return {name: bucket.val > 0 ? `${bucket.val} Bed` : `Studio`,
			 	 count:  bucket.count,
			 	 pct: total > 0 ? (bucket.count / total) * 100 : 0,
			 	 size: stat && stat.avg_unit_size > 0 ? stat.avg_unit_size : bucket.avg_unit_size,
			 	 price: stat.avg_ppsf,
			 	 min_price: stat.min_price,
			 	 max_price: stat.max_price,
			 	 color: getDefaultChartColors[i],
			 	 search : bucket.val == 0 ? 'studio' :  bucket.val > 3 ? '4-or-more' :  bucket.val+'-bedroom'
	}
	 });

	 return data;

  }

  handleClick(e, unit) {
  	const { history, location } = this.props;
  	const base_url = location.pathname.replace('analysis', 'units');
  	history.push(`${base_url}?offering_bedrooms=${unit.search}`);
  }


  render() {
	const { statsRes } = this.props;
	if(!statsRes){
		return null;
	}
	const data = this._generateSalesBreakdown(statsRes);
	const maxCount = Math.max.apply(Math, data.map(unit => unit.count));

	return (
		  <Panel lg={12} xl={12} md={12} title={<Fragment>{"Sales by Bedrooms"} <ToolTip title={"Breakdown of closed sales by bedroom for the selected sale type and time period.  Prices are based on the sold price of each closing."} /></Fragment>}>
		    <div className="sales-by-bed">
		      {data.length === 0 ?
		        <div className="sales-by-bed__empty">No closed sales for the selected filters.</div>
		      :
		      <Fragment>
		      <div className="sales-by-bed__header">
		        <div className="sales-by-bed__label"></div>
		        <div className="sales-by-bed__bar-container">Share of Sales</div>
		        <div className="sales-by-bed__stat">Avg Sold PPSF</div>
		        <div className="sales-by-bed__stat">Sold Range</div>
		        <div className="sales-by-bed__stat">Avg Size</div>
		      </div>
		      {data.map(unit =>
		        <div className="sales-by-bed__row" onClick={(e) => this.handleClick(e, unit)}>
		          <div className="sales-by-bed__label">
		            <span className="dot" style={{ backgroundColor: unit.color }} />{unit.name}
		          </div>
		          <div className="sales-by-bed__bar-container">
		            <div className="sales-by-bed__bar-track">
		              <div className="sales-by-bed__bar-fill" style={{ width: `${maxCount > 0 ? (unit.count / maxCount) * 100 : 0}%`, backgroundColor: unit.color, opacity: 0.35 }} />
		              <span className="sales-by-bed__bar-count"><span className="bold-text">{unit.count}</span> {unit.count === 1 ? 'Sale' : 'Sales'} ({unit.pct.toFixed(0)}%)</span>
		            </div>
		          </div>
		          <div className="sales-by-bed__stat">{unit.price && unit.price > 0 ? `$${_formatNumber(unit.price)}` : '--'}</div>
		          <div className="sales-by-bed__stat">{unit.min_price && unit.min_price > 0 ? `${_formatPrice(unit.min_price)} - ${_formatPrice(unit.max_price)}` : '--'}</div>
		          <div className="sales-by-bed__stat">{unit.size > 0 ? `${_formatNumber(unit.size)} SF` : '--'}</div>
		        </div>
		      )}
		      </Fragment>
		      }
		    </div>
		  </Panel>
	  )

  }
}

export default SalesByBedrooms;
